import React from "react";
import { Control, Controller } from "react-hook-form";
import { MuiTelInput } from "mui-tel-input";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel";
}

const FormPhoneField: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, type, disabled } = props;

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: {
          value: required!,
          message: "Required",
        },
      }}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <MuiTelInput
          fullWidth
          label={label}
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value || ""}
          variant="outlined"
          disabled={disabled}
          defaultCountry="US"
          forceCallingCode
          disableDropdown
        />
      )}
    />
  );
};

export default FormPhoneField;
